/*
 * Olivia Star Jewelry — infinite-loop product gallery
 * Wraps Dawn's <slider-component> inside <media-gallery> so swiping past the
 * last photo (or pressing Next on the last slide) loops back to the first.
 * Same for the previous direction.
 */
(function () {
  'use strict';

  function patchSlider(gallery) {
    if (!gallery || gallery.__oliviaLoopPatched) return;
    var slider = gallery.querySelector('slider-component');
    if (!slider) return;
    var scrollEl = slider.slider;
    if (!scrollEl) return;
    gallery.__oliviaLoopPatched = true;

    // never let a gallery slide sit in the faded-out reveal state
    gallery.querySelectorAll('.product__media-item').forEach(function (s) {
      s.classList.remove('scroll-trigger--offscreen');
    });

    // warm the first few slides right away — the shopper usually starts swiping
    // within a second of landing
    var initial = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
    initial.slice(0, 4).forEach(function (el) {
      el.querySelectorAll('img').forEach(function (img) {
        if (img.loading === 'lazy') img.loading = 'eager';
      });
    });

    // Stop Dawn from disabling Prev/Next at the edges.
    slider.enableSliderLooping = true;
    if (slider.prevButton) slider.prevButton.removeAttribute('disabled');
    if (slider.nextButton) slider.nextButton.removeAttribute('disabled');

    function getItems() {
      return (slider.sliderItemsToShow && slider.sliderItemsToShow.length)
        ? slider.sliderItemsToShow
        : Array.from(slider.sliderItems || []);
    }
    function maxScroll() {
      return scrollEl.scrollWidth - scrollEl.clientWidth;
    }
    function atStart() {
      return scrollEl.scrollLeft <= 2;
    }
    function atEnd() {
      return Math.abs(scrollEl.scrollLeft - maxScroll()) <= 2;
    }

    // The desktop gallery is NOT a horizontal scroller: every slide is collapsed
    // to zero size and only the active one is shown, switched via Dawn's own
    // setActiveMedia(). Scrolling here did nothing, which is why the arrows
    // sometimes landed on an empty frame. Drive the native API instead.
    // Drive the gallery through its own thumbnails.
    //
    // Two earlier attempts failed here, both for instructive reasons:
    //   * scrolling by pixels — the desktop gallery does not scroll at all,
    //     every slide is collapsed and only the active one is shown;
    //   * setActiveMedia(id, true) — the second argument is "prepend", which
    //     physically moves the slide to the front of the list and left the
    //     whole gallery collapsed after a few clicks.
    // Clicking a thumbnail is what the theme itself does, so it stays correct.
    // Thumbnails also hide media belonging to another variant, which is exactly
    // the set we must skip — stepping onto such a slide showed an empty frame.
    function thumbs() {
      return Array.from(gallery.querySelectorAll('.thumbnail-list__item'))
        .filter(function (li) { return li.offsetParent !== null; });
    }

    function activeIndex(list) {
      var i = list.findIndex(function (li) {
        var b = li.querySelector('button');
        return b && b.getAttribute('aria-current') === 'true';
      });
      return i < 0 ? 0 : i;
    }

    // Images are lazy, so warm the neighbours to avoid a blank frame while the
    // file is still on the wire.
    function preload(list, index) {
      [index - 1, index, index + 1].forEach(function (i) {
        var li = list[(i + list.length) % list.length];
        if (!li) return;
        var id = (li.querySelector('button') || {}).dataset;
        var slide = id && id.target
          ? gallery.querySelector('.product__media-item[data-media-id="' + id.target + '"]')
          : null;
        (slide || li).querySelectorAll('img').forEach(function (img) {
          if (img.loading === 'lazy') img.loading = 'eager';
        });
      });
    }

    // Override Next / Prev arrow click — wrap around at the edges.
    function wrapClick(direction) {
      return function (event) {
        var list = thumbs();
        if (list.length < 2) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var index = activeIndex(list);
        var next = direction === 'next' ? index + 1 : index - 1;
        if (next >= list.length) next = 0;          // past the last -> first
        if (next < 0) next = list.length - 1;       // before the first -> last
        preload(list, next);
        var button = list[next].querySelector('button');
        if (button) button.click();
      };
    }

    if (slider.nextButton) slider.nextButton.addEventListener('click', wrapClick('next'), true);
    if (slider.prevButton) slider.prevButton.addEventListener('click', wrapClick('prev'), true);

    // Touch swipe wrap-around on mobile (native horizontal scroll).
    var touchStartX = 0;
    var touchStartScroll = 0;
    scrollEl.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchStartScroll = scrollEl.scrollLeft;
    }, { passive: true });
    scrollEl.addEventListener('touchend', function (e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) < 30) return;
      var items = getItems();
      if (items.length < 2) return;
      var max = maxScroll();
      // Swipe left (dx < 0) while already at the right edge -> jump to start
      if (dx < 0 && touchStartScroll >= max - 4) {
        setTimeout(function () {
          scrollEl.scrollTo({ left: 0, behavior: 'smooth' });
        }, 60);
      }
      // Swipe right (dx > 0) while already at the left edge -> jump to end
      if (dx > 0 && touchStartScroll <= 4) {
        setTimeout(function () {
          scrollEl.scrollTo({ left: max, behavior: 'smooth' });
        }, 60);
      }
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(patchSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-patch when variant change re-renders the gallery
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('load', initAll);
})();
